import { useAssets } from "./useAssets";

export const useFavicons = () => {
  function apply() {
    try {
      const { favicons } = useAssets();
      const faviconsData = favicons.value;

      // Remove favicons existentes
      const existingFavicons = document.querySelectorAll('link[rel*="icon"]');
      existingFavicons.forEach((link) => link.remove());

      // Adiciona novos favicons
      Object.values(faviconsData).forEach((favicon) => {
        const link = document.createElement("link");
        link.rel = "icon";
        link.href = favicon.src;

        if (favicon.size) {
          link.sizes = favicon.size;
        }

        // Apple touch icon especial para o icon180
        if (favicon.size === "180x180") {
          const appleLink = document.createElement("link");
          appleLink.rel = "apple-touch-icon";
          appleLink.href = favicon.src;
          document.head.appendChild(appleLink);
        }

        document.head.appendChild(link);
      });
    } catch (error) {
      console.error("Erro ao aplicar favicons da marca:", error);
    }
  }

  function getFavicons() {
    const { favicons } = useAssets();
    return favicons.value;
  }

  function hasFavicons() {
    try {
      const { favicons } = useAssets();
      favicons.value;
      return true;
    } catch {
      return false;
    }
  }

  return {
    apply,
    getFavicons,
    hasFavicons,
  };
};
